<template>
  <div class="app-container">
    <div class="search-bar flex">
      <div class="left">
        <div class="search-bar">
          <el-input
            v-model="searchParam.keyword_search"
            suffix-icon="el-icon-search"
            placeholder="请输入文字"
            clearable
            @clear="getList"
          ></el-input>
          <el-button type="primary" @click="searchList">搜索</el-button>
        </div>
      </div>
      <div class="right">
        <el-button type="primary" size="small" @click="addItem"> 新增优惠券 </el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="coupon_title" label="优惠券名称"></el-table-column>
        <el-table-column prop="coupon_desc" label="优惠券描述">
          <template v-if="scope.row.coupon_desc" slot-scope="scope">
            {{ scope.row.coupon_desc.substr(0, 25) }}
            <el-popover
              placement="top-start"
              title="优惠券描述"
              width="200"
              trigger="hover"
              :content="scope.row.coupon_desc"
            >
              <span v-if="scope.row.coupon_desc.length > 25" slot="reference">...</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="coupon_type" label="优惠券类型">
          <template slot-scope="scope">
            <label>{{ scope.row.coupon_type == 1 ? "满减" : "其它" }} </label>
          </template>
        </el-table-column>
        <el-table-column prop="use_money" label="使用门槛"></el-table-column>
        <el-table-column prop="" label="已领取/剩余">
          <template slot-scope="scope">
            <label>{{ scope.row.get_num }}/{{ scope.row.limit_num }}</label>
          </template>
        </el-table-column>
        <el-table-column prop="coupon_money" label="面额"></el-table-column>

        <el-table-column label="状态 | 操作" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="editItem(scope.row)">编辑</el-button>
            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
            <el-button class="mid-blue" @click="showUserList(scope.row)">推送</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page_index"
          :limit.sync="listQuery.page_size"
          @pagination="getList"
        />
      </div>
    </div>
    <el-dialog title="用户列表" :visible.sync="showUserDialog">
      <div style="display: flex; margin-bottom: 10px">
        <el-input v-model="listQuery2.keyword_search" placeholder="搜索用户" clearable @clear="getStuList"></el-input>
        <el-button @click="getStuList">查询</el-button>
        <el-button type="primary" @click="toPushAll">发放给所有人</el-button>
      </div>

      <el-table :data="tableData2" height="40vh" :row-key="getRowKey" @selection-change="handlePushUserSelectionChange">
        <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>

        <el-table-column property="real_name" label="用户名"></el-table-column>
        <el-table-column property="mobile" label="手机号"></el-table-column>
      </el-table>

      <!--   <div class="select">
                已选用户：<span v-for="(item,i) in pushUserList">{{ item.username }} <i class="el-icon-close" @click="removeItem(i)"></i> </span>
            </div> -->
      <div class="page">
        <pagination
          v-show="total2 > 0"
          small
          :total="total2"
          :page.sync="listQuery2.page_index"
          :limit.sync="listQuery2.page_size"
          :page-sizes="listQuery2.page_size"
          @pagination="getStuList"
        />
      </div>
      <div class="footer" style="text-align: center">
        <el-button type="primary" :loading="pushLoading" @click="toPush"> 确定 </el-button>
        <el-button @click="cancelPush">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList } from "@/api/user.js";
import { couponList, delCoupon, pushCoupon } from "@/api/operation.js";
import Pagination from "@/components/Pagination";
export default {
  components: { Pagination },
  data() {
    return {
      tableData2: [],
      selList: [],
      total: 10,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      listQuery2: {
        page_index: 1,
        page_size: 10,
        keyword_search: "",
        current_page: 1,
        total: 0,
      },
      total2: 0,
      searchParam: {},
      tableData: [
        {
          id: 1,
          name: "xx x x",
          desc: "满200元减100",
          type: "满减",
          menkan: "101",
          lingqu: "1",
          shengyu: "1000",
          mianer: "100",
          uuid: "aa",
        },
      ],
      // 推送相关参数
      userList: [
        {
          id: 1,
          name: "mmc",
          phone: "11111111",
        },
        {
          id: 2,
          name: "mc",
          phone: "11111111111",
        },
      ],
      pushCouponId: null,
      showUserDialog: false,
      pushUserList: [],
      pushLoading: false,
    };
  },
  created() {
    this.getList();
    this.getStuList();
  },
  methods: {
    getRowKey(row) {
      return row.user_id;
    },
    removeItem(i) {
      this.pushUserList.splice(i, 1);
    },
    async getStuList() {
      const res = await getUserList({ ...this.listQuery2 });
      if (res.data instanceof Array) {
        this.tableData2 = res.data;
        this.total2 = res.total;
      }
    },
    editItem(row) {
      this.$router.push({
        path: "/coupon-add",
        query: { ...row, uuid: row.coupon_id },
      });
    },
    deleteItem(row) {
      this.$confirm("确定要删除该优惠券吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCoupon(row.coupon_id).then((res) => {
            if (res == true) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    showUserList(row) {
      this.showUserDialog = true;
      this.actrow = row;
      this.pushCouponId = row.id;
      this.getUserList();
    },
    getUserList() {
      // TODO : 用户列表接口对接
    },
    handlePushUserSelectionChange(val) {
      this.selList = val;
      this.pushUserList = val;
    },
    toPush() {
      if (this.pushUserList.length === 0) {
        this.$message({
          type: "error",
          message: "至少选择一个推送的用户",
        });
        return;
      }
      this.pushLoading = true;
      pushCoupon({
        coupon_id: this.actrow.coupon_id,
        user_uuids: this.pushUserList.map((it) => {
          return it.uuid;
        }),
      }).then((res) => {
        this.pushLoading = false;
        if (res) {
          this.$message.success("成功");
          this.showUserDialog = false;
        }
      });

      // TODO : 推送接口对接
    },
    toPushAll() {
      this.pushLoading = true;
      pushCoupon({
        coupon_id: this.actrow.coupon_id,
        user_uuids: "all",
      }).then((res) => {
        this.pushLoading = false;
        if (res) {
          this.$message.success("成功");
          this.showUserDialog = false;
        }
      });

      // TODO : 推送接口对接
    },
    cancelPush() {
      this.pushUserList = [];
      this.showUserDialog = false;
    },
    async getList(type) {
      const param = { ...this.searchParam, ...this.listQuery };

      // param[this.skey] = this.searchParam.keyword_search
      this.loading = true;
      const res = await couponList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      } else {
        this.tableData = [];
        this.total = 0;
      }
      console.log(res);
    },
    searchList() {
      this.listQuery.page_index = 1;
      this.getList();
    },
    addItem() {
      this.$router.push({
        path: "/coupon-add",
      });
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.select {
  span {
    display: inline-block;
    background-color: aliceblue;
    padding: 3px 5px;
    margin: 5px 10px;
  }
}
.app-container {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
.footer {
  margin-top: 10px;
}
</style>
